import i18n from '@/js/i18n';
import { isJelMobile } from '@/helpers/AppHelpers';
import router from '@/router/index';
import store from '@/store';

import MessageHelpers from '@/helpers/MessageHelpers';
import { PageMapping } from '@/helpers/PageMappingHelpers';
import { playerPaymentProfileStatus } from '@/helpers/ProfileHelpers';

import api from '@/services/api';

export default {
  async initPaysafeDeposit(oData) {
    const bodyFormData = new FormData();
    bodyFormData.append('amount', oData.amount);
    bodyFormData.append('paymentType', oData.paymentType);
    console.log('initPaysafeDeposit with amount:', bodyFormData.get('amount'));

    return new Promise((resolve, reject) => {
      api
        .call('deposit/init', 'initDeposit', 'POST', {
          headers: {
            'cache-control': 'no-cache',
            'Content-Type': 'multipart/form-data',
            pragma: 'no-cache',
          },
          data: bodyFormData,
          params: {
            lang: i18n.locale,
          },
        })
        .then((response) => {
          console.log('initPaysafeDeposit | response', response.data);
          resolve(response);
        })
        .catch((error) => {
          console.log('initPaysafeDeposit | fail', error);
          reject(error);
        });
    });
  },

  async processDeposit(eData) {
    const bodyFormData = new FormData();
    bodyFormData.append('sut', eData.token);
    bodyFormData.append('amount', eData.amount);
    bodyFormData.append('paymentType', eData.paymentMethod);
    bodyFormData.append('saveCard', eData.saveInstrument || false);
    bodyFormData.append('defaultCard', eData.setInstrumentAsDefault || false);
    bodyFormData.append('merchantRef', eData.merchantRefNum);
    bodyFormData.append('channel', isJelMobile() ? 'M' : 'I');

    console.log('processDeposit with amount:', bodyFormData.get('amount'));

    return new Promise((resolve, reject) => {
      api
        .call('deposit', 'processDeposit', 'POST', {
          headers: {
            'cache-control': 'no-cache',
            'Content-Type': 'multipart/form-data',
            pragma: 'no-cache',
          },
          data: bodyFormData,
        })
        .then((response) => {
          console.log('processDeposit | response', response.data);
          if (response.data?.cardDeposit?.depositInfo) {
            store.commit('depot/SET_DEPOSIT_INFO', response.data?.cardDeposit?.depositInfo);
          }
          if (response.data?.cardDeposit?.paymentReference) {
            store.commit('depot/SET_ES_PAYMENT_REF', response.data?.cardDeposit?.paymentReference);
            store.commit('depot/SET_LQ_EMAIL', response.data?.cardDeposit?.emailLqSendMoney);
            store.commit('depot/SET_MONTANT_ES', response.data?.cardDeposit?.amount);
          }
          resolve(response);
        })
        .catch((error) => {
          console.log('processDeposit | fail', error);
          reject(error);
        });
    });
  },

  async processGooglePayDeposit(eData) {
    const bodyFormData = new FormData();
    bodyFormData.append('sut', eData.paymentHandleToken);
    bodyFormData.append('amount', eData.amount);
    bodyFormData.append('paymentType', eData.paymentMethod);
    bodyFormData.append('saveCard', eData.saveInstrument || false);
    bodyFormData.append('defaultCard', eData.setInstrumentAsDefault || false);
    bodyFormData.append('merchantRef', eData.merchantRefNum);
    bodyFormData.append('channel', isJelMobile() ? 'M' : 'I');

    console.log('processDeposit with amount:', bodyFormData.get('amount'));

    return new Promise((resolve, reject) => {
      api
        .call('deposit', 'processDeposit', 'POST', {
          headers: {
            'cache-control': 'no-cache',
            'Content-Type': 'multipart/form-data',
            pragma: 'no-cache',
          },
          data: bodyFormData,
        })
        .then((response) => {
          console.log('processDeposit | response', response.data);
          if (response.data?.cardDeposit?.depositInfo) {
            store.commit('depot/SET_DEPOSIT_INFO', response.data?.cardDeposit?.depositInfo);
          }
          if (response.data?.cardDeposit?.paymentReference) {
            store.commit('depot/SET_ES_PAYMENT_REF', response.data?.cardDeposit?.paymentReference);
            store.commit('depot/SET_LQ_EMAIL', response.data?.cardDeposit?.emailLqSendMoney);
            store.commit('depot/SET_MONTANT_ES', response.data?.cardDeposit?.amount);
          }
          resolve(response);
        })
        .catch((error) => {
          console.log('processDeposit | fail', error);
          reject(error);
        });
    });
  },

  async getGooglePayInfo() {
    return new Promise((resolve, reject) => {
      api
        .call('deposit/googlepay-info', 'getGooglePayInfo', 'GET')
        .then((response) => {
          console.log('getGooglePayInfo | response', response.data);
          resolve(response);
        })
        .catch((error) => {
          console.log('getGooglePayInfo | fail', error);
          reject(error);
        });
    });
  },

  async getGPPaymentHandleById(paymentHandleId) {
    return new Promise((resolve, reject) => {
      api
        .call(`deposit/googlepay/paymenthandle/${paymentHandleId}`, 'getGPPaymentHandle', 'GET')
        .then((response) => {
          console.log('getGPPaymentHandle | response', response.data);
          resolve(response);
        })
        .catch((error) => {
          console.log('getGPPaymentHandle | fail', error);
          reject(error);
        });
    });
  },

  async depotArgentWeb(couponArgentWeb) {
    const webcashToken = couponArgentWeb;
    const bodyFormData = new FormData();
    bodyFormData.append('webcashToken', webcashToken);
    bodyFormData.append('channel', isJelMobile() ? 'M' : 'I');
    console.log('depotArgentWeb with webCashToken:', bodyFormData.get('webcashToken'));

    return new Promise((resolve, reject) => {
      api
        .call('deposit/web-cash', 'servicesDepotArgentWeb', 'POST', {
          headers: {
            'cache-control': 'no-cache',
            'Content-Type': 'multipart/form-data',
            pragma: 'no-cache',
          },
          data: bodyFormData,
          params: {
            lang: i18n.locale,
          },
        })
        .then((response) => {
          console.log('depotArgentWeb | response', response.data);
          if (response.data?.voucherDeposit?.depositInfo) {
            store.commit('depot/SET_DEPOSIT_INFO', response.data?.voucherDeposit?.depositInfo);
          }
          resolve(response);
        })
        .catch((error) => {
          console.log('depotArgentWeb | fail', error);
          reject(error);
        });
    });
  },

  async obtenirInfoDepot() {
    const profile = await store
      .dispatch('profile/getProfileDetails', {
        depositInfo: true,
        withdrawInfo: false,
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.error('getProfileDetails | failed', error);
        if (error.url) {
          throw error;
        } else {
          throw { url: PageMapping.ERREUR_GENERIQUE.siteUrl };
        }
      });

    return new Promise((resolve, reject) => {
      try {
        const profileDetails = profile.playerPaymentProfile ?? profile;
        if (profileDetails && profileDetails.depositInfo) {
          // On efface le precedent paymentRef du eTransfer ES
          if (profileDetails.depositInfo.esStatus === 'YES') {
            store.commit('profile/RESET_ES_PAYEMENT');
          }
          isProfileValid()
            .then(() => {
              resolve(profile);
            })
            .catch((error) => {
              reject(error);
            });
        } else {
          resolve(false);
        }
      } catch (error) {
        reject(error);
      }
    });
  },

  async cardsNotification(oData) {
    return new Promise((resolve, reject) => {
      api
        .call('deposit/notifications', 'cardsNotification', 'post', {
          headers: {
            'cache-control': 'no-cache',
            'Content-Type': 'application/json',
          },
          data: JSON.stringify(oData),
        })
        .then((response) => {
          console.log('notifications | response', response.data);
          resolve(response);
        })
        .catch((error) => {
          console.log('notifications | fail', error);
          reject(error);
        });
    });
  },

  async initPaysafeJSFrame(paymentMethod) {
    return new Promise((resolve, reject) => {
      const headers = {
        'Content-Type': 'application/json',
        'request-id': 'fetch-identity-verification',
      };

      api
        .call(`deposit/apple-pay-init`, 'applePayInit', 'GET', {
          headers,
        })
        .then((response) => {
          console.log('merchant-account | response', response.data);
          resolve(response);
        })
        .catch((error) => {
          console.log('merchant-account | fail', error);
          reject(error);
        });
    });
  },
};

async function isProfileValid() {
  // Efface les messages de dépôt du store
  store.commit('profile/RESET_MESSAGES');

  // Dépôt bloqué ou non autorisé
  if (store.getters['depot/isDepotBloque'] || store.getters['depot/isUnauthorized']) {
    await sauverMessage('MSG04-50');
    throw { url: PageMapping.DEPOT_NON_AUTORISE.siteUrl };
  }
  // Client Guest
  if (store.getters['profile/hasStatus'](playerPaymentProfileStatus.GUEST)) {
    router.push(
      store.getters['routes/getUrlFromWebsitePath'](PageMapping.IDENTITE_REPRISE.siteUrl)
    );
    return false;
  }
  // Limite dépôt non définie
  if (!store.getters['depot/hasDepositLimit']) {
    router.push(store.getters['routes/getUrlFromWebsitePath'](PageMapping.LIMITE_DEPOT.siteUrl));
    return false;
  }
  // Limite hebdomadaire dépassée (CC & Webcash)
  if (
    store.getters['depot/isDepositLimitReached'] &&
    store.getters['depot/depositInfo'].webcashMaximumAmount == 0
  ) {
    await sauverMessage('MSG04-35');
    throw { url: PageMapping.DEPOT_NON_AUTORISE.siteUrl };
  }
  return true;
}

function sauverMessage(msgCode) {
  MessageHelpers.obtenirMessage(msgCode)
    .then((msgResp) => {
      const msgDetails = modifierMessage(msgResp.msgDetail);
      const msg = {
        title: msgResp.msgTitre,
        details: msgDetails,
      };
      store.commit('profile/SET_MESSAGE_DEPOT', msg);
      return msgResp;
    })
    .catch((error) => {
      console.log('Erreur de récupération du message', error);
    });
}

/*
 * Messages provenant de l'App Message sont encapsulées dans des spans.
 * Changement des balises pour uniformiser le padding des affichages
 */
function modifierMessage(message) {
  if (message.includes('<span>')) {
    message = message.replaceAll('<span>', '').replaceAll('</span>', '');
  }
  if (message.includes('<p>')) {
    message = message.replaceAll('<p>', '').replaceAll('</p>', '');
  }
  return message;
}
